import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext, useMemo } from 'react';
import cns from '../../node_modules/classnames/index.js';
import SidebarContext from './SidebarContext.js';

function Menu({ children }) {
    const { open, openCallback } = useContext(SidebarContext);
    const classes = useMemo(() => cns('sidebar__menu', {
        'sidebar__menu--open': open,
        'sidebar__menu--closed': !open,
    }), [open]);
    return (jsxs("div", { className: classes, children: [jsx("div", { className: "sidebar__menu__header", children: jsx("div", { className: "sidebar__menu__hamburger", onClick: openCallback, role: "presentation", children: jsx("div", { className: "sidebar__menu__hamburger__box", children: jsx("div", { className: "sidebar__menu__hamburger__inner" }) }) }) }), children] }));
}
Menu.defaultProps = {
    children: null,
};

export { Menu as default };
